import { TableBlockSchema } from '@blocksuite/affine-model';
import {
  BlockNotionHtmlAdapterExtension,
  type BlockNotionHtmlAdapterMatcher,
  HastUtils,
  isNotionDatabaseTable,
} from '@blocksuite/affine-shared/adapters';

import { openTableBlockFromHtml } from './utils';

/** A Notion simple table is a table block; a Notion database is not. */
export const tableBlockNotionHtmlAdapterMatcher: BlockNotionHtmlAdapterMatcher =
  {
    flavour: TableBlockSchema.model.flavour,
    toMatch: o =>
      HastUtils.isElement(o.node) &&
      o.node.tagName === 'table' &&
      !isNotionDatabaseTable(o.node),
    fromMatch: () => false,
    toBlockSnapshot: {
      enter: (o, context) => {
        if (!HastUtils.isElement(o.node)) return;
        openTableBlockFromHtml(
          o.node,
          context.walkerContext,
          context.deltaConverter.astToDelta.bind(context.deltaConverter)
        );
      },
      leave: (_o, context) => {
        context.walkerContext.closeNode();
      },
    },
    fromBlockSnapshot: {},
  };

export const TableBlockNotionHtmlAdapterExtension =
  BlockNotionHtmlAdapterExtension(tableBlockNotionHtmlAdapterMatcher);
